/**
 * Zustand der Places-Vorschlagsliste für die Tastaturführung
 * (docs/TASTATURGEFUEHRTE_FAHRTERFASSUNG.md, Abschnitt 3.4).
 *
 * Google gibt nicht preis, ob gerade Vorschläge angezeigt werden. Der Zustand
 * wird deshalb aus den Events abgeleitet und in `data-*`-Attributen am Feld
 * hinterlegt, wo useFormKeyboardNav ihn beim Tastendruck ausliest:
 *
 *   data-nav-open      Enter gehört der Vorschlagsliste, nicht der Navigation
 *   data-nav-selected  in diesem Feld wurde bereits ein Ort bestätigt
 *   data-nav-length    letzte Eingabelänge, um Tippen von Löschen zu trennen
 *
 * Der entscheidende Punkt ist `navSelected`: Nach einer Auswahl hat das Feld
 * Koordinaten, und was danach getippt wird, ist die Hausnummer. Würde jede
 * Eingabe die Liste erneut als offen markieren, käme das Feld nie wieder aus
 * diesem Zustand heraus – Enter würde dauerhaft an Google durchgereicht und der
 * Disponent bliebe im Adressfeld hängen.
 *
 * Alle Funktionen arbeiten auf einem `dataset` (DOMStringMap oder einfaches
 * Objekt), damit die Logik ohne DOM prüfbar bleibt.
 */

/** Nutzer hat getippt oder gelöscht. */
export const noteSuggestionInput = (dataset, value = '') => {
  const previousLength = Number(dataset.navLength || 0);
  dataset.navLength = String(value.length);

  // Feld geleert → wieder ganz von vorn.
  if (!value) {
    delete dataset.navSelected;
    delete dataset.navOpen;
    return;
  }

  // Gelöscht statt getippt heißt: Die Adresse wird überarbeitet, die bisherige
  // Auswahl gilt nicht mehr.
  if (value.length < previousLength) {
    delete dataset.navSelected;
  }

  if (dataset.navSelected) {
    delete dataset.navOpen;
  } else {
    dataset.navOpen = 'true';
  }
};

/** Ein Vorschlag wurde übernommen (Enter oder Mausklick). */
export const noteSuggestionSelected = (dataset, formattedAddress = '') => {
  delete dataset.navOpen;
  dataset.navSelected = 'true';
  dataset.navLength = String(formattedAddress.length);
};

/**
 * Tastendruck im Feld. Pfeiltasten heißen: Der Disponent geht bewusst durch die
 * Vorschläge – dann gehört das nächste Enter wieder der Liste, auch nach einer
 * bereits getroffenen Auswahl (etwa um die Adresse mit Hausnummer zu
 * präzisieren).
 */
export const noteSuggestionKey = (dataset, key) => {
  if (key === 'ArrowDown' || key === 'ArrowUp') {
    dataset.navOpen = 'true';
  } else if (key === 'Escape') {
    delete dataset.navOpen;
  }
};

/** Feld verlassen – die Liste ist in jedem Fall zu. */
export const noteSuggestionClosed = (dataset) => {
  delete dataset.navOpen;
};
